export default {
  SET_THEME(state, theme) {
    state.theme = theme;
  },

  SET_WEBSITE(state, website) {
    state.website = website;
  },

  SET_THEMES(state, themes) {
    state.themes = themes;
  },
};
